import { DatePipe } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faShareFromSquare } from '@fortawesome/free-regular-svg-icons';
import { JobPostingResponse } from 'src/app/services/openapi/model/models';
import { SharePostingComponent } from 'src/app/shared/components/share-posting/share-posting.component';
import { COUNTRY_SUBDIVISIONS, PCL_OPERATING_COUNTRIES } from 'src/app/shared/constants';

@Component({
  selector: 'app-posting',
  imports: [RouterModule, MatButtonModule, MatCardModule, DatePipe, FaIconComponent],
  templateUrl: './posting.component.html',
  styleUrl: './posting.component.scss',
})
export class PostingComponent implements OnInit {
  @Input({ required: true }) posting!: JobPostingResponse;
  private readonly dialog: MatDialog = inject(MatDialog);
  public readonly faShareFromSquare = faShareFromSquare;
  public locationDisplay = signal<string>('');
  public ariaLabel = signal<string>('Share posting');

  ngOnInit(): void {
    this.locationDisplay.set(this.getPostingLocationDisplayString(this.posting));
    this.ariaLabel.set(`Share ${this.posting.jobTitle} job posting`);
  }

  private getPostingLocationDisplayString(jobPosting: JobPostingResponse): string {
    const strings = [
      jobPosting.city,
      COUNTRY_SUBDIVISIONS[jobPosting.isoSubdivisionCode] ?? jobPosting.isoSubdivisionCode,
      PCL_OPERATING_COUNTRIES[jobPosting.isoCountryCode] ?? jobPosting.isoCountryCode,
    ].filter((x) => x);
    return strings.join(', ');
  }

  public openDialog(posting: JobPostingResponse) {
    this.dialog.open(SharePostingComponent, {
      data: posting,
      autoFocus: false,
    });
  }
}
